import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';
import '../scss/main.scss';
import HorizontalBarChart from './HorizontalBarChart';
import Lottie from 'react-lottie-player'
import successImage from '../animations/success.json';

export default function Evaluation({user}) {
	const {id} = useParams();
	const [loading, setLoading] = useState(false);
	const [err, setErr] = useState(null);
	const [evaluation, setEvaluation] = useState(null);
	const [totals, setTotals] = useState([0, 0, 0, 0, 0]);
	const [page, setPage] = useState('results');

	const goBack = () => {
		window.history.back()
	}
	useEffect(() => {
		if(!id) return;
		api.getEvaluation(id, user.token)
			.then(({ data }) => {
				if (data.status === 'SUCCESS') {
					if(data.data === 'locked'){
						setPage('success')
					}else{
						setPage('results');
						setEvaluation(data.data[0]);
					}
				} else {
					setErr('An error occured. Please try again later');
				}
			})
			.catch((e) => {
				setErr('An error occured. Please try again later');
				console.log(e);
			})
			.finally(() => setLoading(false))
	}, [id])
	useEffect(() => {
		if(!evaluation) return;

		const totals = evaluation.questions.reduce((res, question) => {
			if(question.type === 'hard'){
				res[1]+= question.score;
				res[2] += 1;
			}else{
				res[3] += question.score;
				res[4] += 1;
			}
			res[0] += question.score;
			return res;
		}, [0, 0, 0, 0, 0])
		setTotals(totals);
	}, evaluation)
	const getTotal = (type) => {
		switch (type) {
			case 'total':
				let t = totals[0] / evaluation.questions.length
				return (Math.round(t)).toFixed(0);
			case 'soft':
				let s = totals[3] / totals[4]
				return (Math.round(s)).toFixed(0);
			case 'hard':
				let h = totals[1] / totals[2]
				return (Math.round(h)).toFixed(0);
			default:
				break;
		}
	}
	return (
		<div className="page">
			{page === 'success' &&
				<div className="card card__rounded text__center">
					<Lottie
						loop
						animationData={successImage}
						play
						style={{ width: 250, height: 250, margin: 'auto' }}
					/>
					<h4>Thank you for taking the time to answer our questions. We will contact you shortly for the next steps.</h4>
				</div>
			}
			{evaluation &&
				<div>
					<div className="card">
						<div className="flex flex__row">
							<b className="btn btn__light" onClick={goBack}>
								<span className="material-icons font__20">
									arrow_back_ios
								</span>
								Back
							</b>
							<h4 className="float--right">Report</h4>
						</div>
						<div className="page__title">
							<div>Position: {evaluation.job_title}</div>
							<div>Name: <b className="capitalize">{evaluation.name} {evaluation.surname}</b></div>
						</div>
					</div>
					{totals !== null &&
						<div className="card flex flex__row report__scores">
							<div className="card report__score">
								<div className="text-xl">Overall Score</div>
								<div className="result__item">
									<div class="pie animate no-round" style={{ '--p': getTotal('total') }}> {getTotal('total')}%</div>
								</div>
							</div>
							<div className="card report__score">
								<div className="text-xl">Average Soft Skills Score</div>
								<div className="result__item">
									<div class="pie animate no-round" style={{ '--p': getTotal('soft') }}> {getTotal('soft')}%</div>
								</div>
							</div>
							<div className="card report__score">
								<div className="text-xl">Average Hard Skills Score</div>
								<div className="result__item">
									<div class="pie animate no-round" style={{ '--p': getTotal('hard') }}> {getTotal('hard')}%</div>
								</div>
							</div>
						</div>
					}
					<div className="text-left mt-5">
						<div className="card">
							{evaluation.questions.map((question, idx) => {
								return (
									<div className="result__item" key={`result_${idx}`}>
										<HorizontalBarChart data={question} />
									</div>
								)
							})}
						</div>
					</div>
				</div>
			}
			
		</div>
	)
}